import { Dialog } from "@headlessui/react";
import { X } from "lucide-react";
import { TripWithRole } from "../types";

interface TripSelectModalProps {
  open: boolean;
  onClose: () => void;
  trips: TripWithRole[];
  onSelectTrip: (tripId: string) => void;
}

export default function TripSelectModal({
  open,
  onClose,
  trips,
  onSelectTrip,
}: TripSelectModalProps) {
  return (
    <Dialog open={open} onClose={onClose} className="fixed inset-0 z-50">
      <div className="fixed inset-0 bg-black/60" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="bg-[#161b27] border border-[#2a3347] w-full max-w-md rounded-2xl p-6 relative">
          <button
            onClick={onClose}
            className="absolute top-3 right-4 text-slate-600 hover:text-slate-300 text-xl transition-colors"
          >
            <X className="w-4 h-4" />
          </button>

          <Dialog.Title className="text-sm font-semibold text-slate-100 mb-5 text-center">
            Wähle eine Reise
          </Dialog.Title>

          <div className="space-y-2 max-h-[60vh] overflow-y-auto">
            {trips.length === 0 && (
              <p className="text-sm text-slate-500 text-center">
                Du bist noch kein Organisator einer Reise.
              </p>
            )}
            {trips.map((trip) => (
              <button
                key={trip.id}
                onClick={() => onSelectTrip(trip.id)}
                className="w-full text-left px-4 py-3 bg-[#1e2639] border border-[#2a3347] rounded-xl hover:border-sky-500/20 transition-colors"
              >
                <div className="text-sm font-medium text-slate-100">{trip.name}</div>
                <div className="text-xs text-slate-500 mt-0.5">
                  {trip.start_date} – {trip.end_date}
                </div>
                <div className="text-xs mt-1 text-sky-400/70">
                  {trip.role === "creator" ? "Ersteller" : "Mitorganisator"}
                </div>
              </button>
            ))}
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
